import React from "react";
import pageNotFound from "../Assets/img/UI/pagenotFound.png";

const NoPage = () => {
  return (
    <div className="p-2 md:p-4 h-[calc(100vh-4rem)] overflow-scroll">
      <img src={pageNotFound} alt="page Not found" />
    </div>
  );
};

export default NoPage;
